import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Vehicule } from 'src/app/model/data-managemnt';
import { MapService } from 'src/app/utils/leaflet/service/map.service';
import { DataManagementService } from '../../data-management/data-management.service';
import { HistoricalService } from '../../historical/historical.service';
import * as L from 'leaflet';
import Marker = L.Marker;
import { DatePipe } from '@angular/common';
import { GlobalService } from 'src/app/global.config';
import { PromptComponent } from '../prompt/prompt.component';
import {AlertController, ModalController, PopoverController} from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import {TrackControleComponent} from "../../../utils/leaflet/track-controle/track-controle.component";
import { Capacitor } from '@capacitor/core';
import { Geolocation } from '@capacitor/geolocation';
import { Browser } from '@capacitor/browser';
import { StartNavigation } from '@proteansoftware/capacitor-start-navigation';


@Injectable({
  providedIn: 'root'
})
export class PopupService {
  id1: any;
  playbackIndex: number = 0;
  playbackInterval: any;
  playbackStarted: boolean = true;
  polyline: any;
  endMarker: Marker;
  currentPlaybackMarker: Marker;
  id2: any;
  liveReloadingRT: any
  currentPathClickedDeviceId: number;
  isCurrentPathClicked: boolean;
  positionMarker: any;
  circle: any;
  isClicked: boolean = false;
  hideCurrentPath: boolean = true
  currentlocationlat: any;
  currentlocationlng: any;
  marker: any
  showBackButton: boolean = false
  constructor(
    private router: Router,
    private dataManagementService: DataManagementService,
    private mapService: MapService,
    private historicalService: HistoricalService,
    private globalService: GlobalService,
    private popoverCtrl: PopoverController,
    private translate: TranslateService,
    private alertCtrl: AlertController,
    private modalController: ModalController,
    private datePipe:DatePipe
  ) { }


  getVehicule(idDevice: number): Vehicule[] {
    let foundVehicule :any[] =[];
    if (!this.dataManagementService.groups)
      return [];
    for (let i = 0; i < this.dataManagementService.groups.length; i++) {
      for (let j = 0; j < this.dataManagementService.groups[i].vehicules.length; j++) {
        if (this.dataManagementService.groups[i].vehicules[j].device != null &&
          this.dataManagementService.groups[i].vehicules[j].device.idDevice === idDevice) {
          foundVehicule.push(this.dataManagementService.groups[i].vehicules[j] as never);
        }
      }
    }
    return foundVehicule;

  }

  voirHistorique() {
    this.hideCurrentPath = true
    this.router.navigate(['/path']);
  }


  /**
   * Open track control modal instead of navigating to a new page
   */
  async openTrackControlModal(playBackPath: any, trackType: string) {
    const modal = await this.modalController.create({
      component: TrackControleComponent,
      componentProps: {
        trackData: playBackPath,
        trackType: trackType
      },
      cssClass: 'track-control-modal',
      backdropDismiss: true,
      showBackdrop: true
    });
    modal.onDidDismiss().then(() => {
      modal.dismiss();
    })

    await modal.present();

    // Handle modal dismissal if needed
    const { data } = await modal.onWillDismiss();
    if (data) {
      console.log('Modal dismissed with data:', data);
      // Handle any data returned from the modal
    }
  }
  displayTodaysMileage(vehicule: Vehicule) {
    // this.showBackButton = true
    // this.hideCurrentPath = true
    // this.mapService.removePolylinesFromMap();
    // this.mapService.removeMarkersFromMap();
    let today = new Date();
    this.historicalService
      .getAllMileages(vehicule.idDevice, {
        startDate: new Date(
          today.getFullYear(),
          today.getMonth(),
          today.getDate(),
          0,
          0,
          0
        ),
        endDate: new Date(
          today.getFullYear(),
          today.getMonth(),
          today.getDate(),
          23,
          59,
          59
        )
      })
      .subscribe(
        mileages => {
          vehicule.mileage = this.historicalService.mileages[mileages.length - 1];
        },
        () => { }
      );

    let date = new Date();
    date.setHours(0, 0, 0, 0);
    let startHour: any = date.getTime();
    this.historicalService
      .getTodaysMileage(vehicule.device.idDevice, {
        startDate: startHour,
        endDate: startHour
      })
      .subscribe(
        mileage => {
          console.log("this is mileage", mileage);
          this.openTrackControlModal(mileage,"mileage");
        });
  }


  async arreterDemarrer(ev: any, vehic: any) {
    this.hideCurrentPath = true
    let vehicule = vehic.idDevice;
    let group = this.dataManagementService.selectedGroup;
    let selectedV = { "group": group, "vehicule": vehicule, "indexGroup": this.id1, "indexVehicule": this.id2 };

    let popover = await this.popoverCtrl.create({
      component: PromptComponent,
      event: ev,
      translucent: false,
      cssClass: 'marcheArret'
    });
    return await popover.present();
  }



  displayCurrentPath(deviceId: number) {
    this.showBackButton = true;
    this.hideCurrentPath = false;
    this.mapService.removePolylinesFromMap();
    this.mapService.removeMarkersFromMap();
    this.isCurrentPathClicked = false; // Reset the flag

    this.historicalService.getCurrentPath(deviceId).subscribe({
      next: (currentPath) => {
        console.log("this is current path", currentPath);
        if (currentPath != null) {
          this.openTrackControlModal(currentPath, "currentkm");
        }
      },
      error: (err) => {
        console.error("Erreur lors de la récupération du chemin actuel", err);
        // Autres actions de gestion d’erreur si nécessaire
      }
    });
  }

  startPlayback(polyline: any) {
    this.playbackStarted = !this.playbackStarted; // Set to true when starting
    console.log(this.playbackStarted);
    this.playbackIndex = 0;

    // Remove any existing playback interval
    this.stopPlayback();

    // Start playback
    this.playbackInterval = setInterval(() => {
      if (this.playbackIndex < polyline.getLatLngs().length) {
        let currentPosition = polyline.getLatLngs()[this.playbackIndex];
        this.mapService.map.panTo(currentPosition);

        // Move current playback marker to the current position
        this.currentPlaybackMarker.setLatLng(currentPosition);

        // Access latitude and longitude from currentPosition
        let latitude = currentPosition.lat;
        let longitude = currentPosition.lng;

        // Access time and startTime from currentPath (assuming currentPath is available)
        let time, startTime;
        // ... (you need to set time and startTime)

        // Update the popup content for the current playback marker
        this.currentPlaybackMarker.setPopupContent(
          "<b> <i>[lat: </b>" +
          latitude +
          "<b> ,long: </b>" +
          longitude +
          "<b>]</i><br>" +
          time +
          ' </b>' +
          this.datePipe.transform(
            startTime,
            'dd/MM/yyyy HH:mm:ss',
            'en-US'
          )
        );

        this.currentPlaybackMarker.openPopup();

        this.playbackIndex++;
      } else {
        this.stopPlayback();
      }
    }, 1000); // Update every 1 second (adjust as needed)
  }

  stopPlayback() {
    this.playbackStarted = !this.playbackStarted; // Set to false when stopping
    if (this.playbackInterval) {
      clearInterval(this.playbackInterval);
      this.playbackInterval = null;
    }
    this.playbackIndex = 0;
  }


  async currentPosition(vehicule: any, currentlocationlat?: any, currentlocationlng?: any) {
    this.showBackButton = true;
    this.hideCurrentPath = true;

    const coords = await this.resolveUserLocation(currentlocationlat, currentlocationlng);
    if (!coords) {
      await this.handleError(this.translate.instant('REALTIME.enableGps'));
      return;
    }

    const { lat, lng } = coords;
    this.currentlocationlat = lat;
    this.currentlocationlng = lng;

    let vehicules = this.getVehicule(vehicule.idDevice);

    if (!this.isClicked) {
      this.mapService.map.flyTo(L.latLng(lat, lng), 15);
      this.positionMarker = L.marker([lat, lng]).addTo(this.mapService.map);
      this.circle = L.circle([lat, lng], {
        fillOpacity: 0.2,
        radius: 500
      }).addTo(this.mapService.map);

      this.isClicked = !this.isClicked;
    } else {
      if (this.positionMarker) {
        this.mapService.map.removeLayer(this.positionMarker);
      }
      if (this.circle) {
        this.mapService.map.removeLayer(this.circle);
      }
      if (vehicules?.[0]?.realTimeRecord?.coordinate) {
        this.mapService.map.setView(
          L.latLng(
            vehicules[0].realTimeRecord.coordinate.lat,
            vehicules[0].realTimeRecord.coordinate.lng
          ),
          8
        );
      }
      this.isClicked = !this.isClicked;
    }
  }

  async drawpath(vehicule: any, _currentlocationlat?: any, _currentlocationlng?: any) {
    this.hideCurrentPath = true;
    if (!vehicule) {
      await this.handleError(this.translate.instant('REALTIME.chooseVehicle'));
      return;
    }

    const vehicules = this.getVehicule(vehicule.idDevice);
    const destination = vehicules?.[0]?.realTimeRecord?.coordinate;
    if (destination?.lat == null || destination?.lng == null) {
      await this.handleError(this.translate.instant('REALTIME.chooseVehicle'));
      return;
    }

    // Direction only needs the vehicle destination — do NOT block on phone GPS.
    const destLat = Number(destination.lat);
    const destLng = Number(destination.lng);
    const name = vehicules[0].matricule || 'Destination';
    const mapsUrl =
      `https://www.google.com/maps/dir/?api=1` +
      `&destination=${encodeURIComponent(`${destLat},${destLng}`)}` +
      `&travelmode=driving`;

    try {
      // Prefer Google Maps URL first — StartNavigation can hang on some iOS builds.
      if (Capacitor.isNativePlatform()) {
        try {
          await Browser.open({ url: mapsUrl });
          return;
        } catch (browserErr) {
          console.warn('Browser.open maps failed, trying StartNavigation', browserErr);
        }

        try {
          await this.withTimeout(
            StartNavigation.launchMapsApp({
              latitude: destLat,
              longitude: destLng,
              name,
              travelMode: 'driving',
            }),
            4000,
            'StartNavigation timeout'
          );
          return;
        } catch (nativeErr) {
          console.warn('StartNavigation failed', nativeErr);
        }
      }

      window.open(mapsUrl, '_blank');
    } catch (error) {
      console.error('Error opening maps for directions:', error);
      await this.handleError(this.translate.instant('REALTIME.installGoogleMaps'));
    }
  }

  /**
   * Get current GPS coords on web (ng serve), Android, and iOS.
   * Falls back to cached lat/lng when a fresh fix is unavailable.
   */
  async resolveUserLocation(
    cachedLat?: any,
    cachedLng?: any
  ): Promise<{ lat: number; lng: number } | null> {
    if (this.locationRequestInFlight) {
      return this.locationRequestInFlight;
    }

    this.locationRequestInFlight = this.fetchUserLocation(cachedLat, cachedLng);
    try {
      return await this.locationRequestInFlight;
    } finally {
      this.locationRequestInFlight = null;
    }
  }

  private locationRequestInFlight: Promise<{ lat: number; lng: number } | null> | null = null;

  private async fetchUserLocation(
    cachedLat?: any,
    cachedLng?: any
  ): Promise<{ lat: number; lng: number } | null> {
    const cached = this.asValidCoords(
      cachedLat ?? this.currentlocationlat,
      cachedLng ?? this.currentlocationlng
    );

    try {
      // Browser / ng serve: use the standard Web Geolocation API.
      if (!Capacitor.isNativePlatform()) {
        const webCoords = await this.getBrowserPosition();
        if (webCoords) {
          return webCoords;
        }
        if (cached) {
          return cached;
        }
        await this.handleError(this.translate.instant('REALTIME.enableGps'));
        return null;
      }

      // Native iOS / Android: Capacitor Geolocation + permissions.
      const permission = await this.withTimeout(
        Geolocation.checkPermissions(),
        3000,
        'checkPermissions timeout'
      ).catch(() => ({ location: 'prompt', coarseLocation: 'prompt' } as any));
      console.log('[Geo] checkPermissions', permission);

      if (permission?.location === 'denied') {
        console.warn('[Geo] location denied');
        if (cached) {
          return cached;
        }
        await this.handleError(this.translate.instant('REALTIME.enableGps'));
        return null;
      }

      if (permission?.location !== 'granted' && permission?.coarseLocation !== 'granted') {
        try {
          const requested = await this.withTimeout(
            Geolocation.requestPermissions(),
            8000,
            'requestPermissions timeout'
          );
          console.log('[Geo] requestPermissions', requested);
        } catch (permErr) {
          console.warn('[Geo] requestPermissions failed/timed out', permErr);
        }
      }

      const position = await this.withTimeout(
        Geolocation.getCurrentPosition({
          enableHighAccuracy: true,
          timeout: 12000,
          maximumAge: 10000,
        }),
        15000,
        'getCurrentPosition timeout'
      );
      console.log('[Geo] native position', position.coords.latitude, position.coords.longitude);
      return {
        lat: position.coords.latitude,
        lng: position.coords.longitude,
      };
    } catch (error) {
      console.error('[Geo] Error getting current position:', error);
      if (cached) {
        return cached;
      }
      // Last resort on native: try browser API if available inside the WebView.
      try {
        const webCoords = await this.getBrowserPosition();
        if (webCoords) {
          return webCoords;
        }
      } catch {
        // ignore
      }
      await this.handleError(this.translate.instant('REALTIME.enableGps'));
      return null;
    }
  }

  /** Works on ng serve / desktop browsers (HTTPS or localhost). */
  private getBrowserPosition(): Promise<{ lat: number; lng: number } | null> {
    return new Promise((resolve) => {
      if (typeof navigator === 'undefined' || !navigator.geolocation) {
        console.warn('[Geo] navigator.geolocation not available');
        resolve(null);
        return;
      }

      navigator.geolocation.getCurrentPosition(
        (position) => {
          console.log('[Geo] browser position', position.coords.latitude, position.coords.longitude);
          resolve({
            lat: position.coords.latitude,
            lng: position.coords.longitude,
          });
        },
        (err) => {
          console.warn('[Geo] browser geolocation error', err);
          resolve(null);
        },
        {
          enableHighAccuracy: true,
          timeout: 15000,
          maximumAge: 10000,
        }
      );
    });
  }

  private withTimeout<T>(promise: Promise<T>, ms: number, label: string): Promise<T> {
    return new Promise<T>((resolve, reject) => {
      const timer = setTimeout(() => reject(new Error(label)), ms);
      promise
        .then((value) => {
          clearTimeout(timer);
          resolve(value);
        })
        .catch((err) => {
          clearTimeout(timer);
          reject(err);
        });
    });
  }

  private asValidCoords(lat: any, lng: any): { lat: number; lng: number } | null {
    const parsedLat = Number(lat);
    const parsedLng = Number(lng);
    if (!Number.isFinite(parsedLat) || !Number.isFinite(parsedLng)) {
      return null;
    }
    return { lat: parsedLat, lng: parsedLng };
  }

  async handleError(mess: String) {
    let alert = await this.alertCtrl.create({
      header: 'GPS',
      message: '' + mess,
      buttons: ['Ok']
    });
    await alert.present();
  }


}
